import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SchoolMap = ({ schools, onSchoolSelect }) => {
  const [selectedMarker, setSelectedMarker] = useState(null);

  // Senegal map center coordinates
  const mapCenter = { lat: 14.4974, lng: -14.4524 };

  const handleMarkerClick = (school) => {
    setSelectedMarker(school?.id === selectedMarker ? null : school?.id);
  };

  const selectedSchool = schools?.find(s => s?.id === selectedMarker);

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      {/* Map Container */}
      <div className="relative h-[500px] md:h-[600px] bg-gradient-to-br from-blue-100 to-green-100">
        {/* Map Placeholder with Markers */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <Icon name="Map" size={64} color="#9CA3AF" className="mx-auto mb-4" />
            <p className="text-gray-600 mb-2">Carte interactive des établissements</p>
            <p className="text-sm text-gray-500">Cliquez sur les marqueurs pour voir les détails</p>
          </div>
        </div>

        {/* School Markers */}
        <div className="absolute inset-0">
          {schools?.map((school, index) => {
            // Calculate position based on coordinates (simplified positioning)
            const left = ((school?.coordinates?.lng + 17.5) / 3.5) * 100;
            const top = ((16.7 - school?.coordinates?.lat) / 2.7) * 100;

            return (
              <button
                key={school?.id}
                onClick={() => handleMarkerClick(school)}
                className={`absolute transform -translate-x-1/2 -translate-y-1/2 transition-all ${
                  selectedMarker === school?.id ? 'scale-125 z-10' : 'hover:scale-110'
                }`}
                style={{ left: `${left}%`, top: `${top}%` }}
              >
                <div className="relative">
                  <Icon
                    name="MapPin"
                    size={32}
                    color={selectedMarker === school?.id ? '#EF4444' : '#3B82F6'}
                    fill={selectedMarker === school?.id ? '#EF4444' : '#3B82F6'}
                  />
                  {selectedMarker === school?.id && (
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-white rounded-lg shadow-lg p-3 w-64 z-20">
                      <h4 className="font-semibold text-gray-800 mb-1 text-sm">{school?.name}</h4>
                      <p className="text-xs text-gray-600 mb-2">{school?.location}</p>
                      <div className="flex gap-2">
                        <Button
                          size="xs"
                          variant="default"
                          onClick={(e) => {
                            e?.stopPropagation();
                            onSchoolSelect(school);
                          }}
                        >
                          Détails
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>

        {/* Map Controls */}
        <div className="absolute top-4 right-4 flex flex-col gap-2">
          <button className="bg-white p-2 rounded-lg shadow-md hover:bg-gray-50">
            <Icon name="Plus" size={20} color="#374151" />
          </button>
          <button className="bg-white p-2 rounded-lg shadow-md hover:bg-gray-50">
            <Icon name="Minus" size={20} color="#374151" />
          </button>
          <button className="bg-white p-2 rounded-lg shadow-md hover:bg-gray-50">
            <Icon name="Maximize" size={20} color="#374151" />
          </button>
        </div>

        {/* Legend */}
        <div className="absolute bottom-4 left-4 bg-white rounded-lg shadow-md p-3">
          <h4 className="text-sm font-semibold text-gray-800 mb-2">Légende</h4>
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <Icon name="MapPin" size={16} color="#3B82F6" fill="#3B82F6" />
              <span className="text-xs text-gray-600">Établissement</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="MapPin" size={16} color="#EF4444" fill="#EF4444" />
              <span className="text-xs text-gray-600">Sélectionné</span>
            </div>
          </div>
        </div>
      </div>
      {/* School List Below Map */}
      <div className="p-4 border-t border-gray-200">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          <Icon name="List" size={20} />
          Établissements sur la carte ({schools?.length})
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 max-h-64 overflow-y-auto">
          {schools?.map((school) => (
            <button
              key={school?.id}
              onClick={() => handleMarkerClick(school)}
              className={`text-left p-3 rounded-lg border transition-all ${
                selectedMarker === school?.id
                  ? 'border-blue-500 bg-blue-50' :'border-gray-200 hover:border-blue-300 hover:bg-gray-50'
              }`}
            >
              <h4 className="font-semibold text-sm text-gray-800 mb-1">{school?.name}</h4>
              <p className="text-xs text-gray-600 flex items-center gap-1">
                <Icon name="MapPin" size={12} />
                {school?.location}
              </p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SchoolMap;